module.exports = __webpack_public_path__ + "static_pc/img/int05.338b333c.png";